import Editor from "@monaco-editor/react";

import { Button } from "@/components/ui/button";

interface CodeEditorProps {
  value: string;
  path: string;
  onChange?: (value: string) => void;
  onSave?: () => void;
  readOnly?: boolean;
}

function guessLanguage(path: string): string {
  const ext = path.split(".").pop()?.toLowerCase();
  switch (ext) {
    case "ts":
    case "tsx":
      return "typescript";
    case "js":
    case "jsx":
      return "javascript";
    case "json":
      return "json";
    case "py":
      return "python";
    case "md":
      return "markdown";
    case "html":
      return "html";
    case "css":
      return "css";
    case "sql":
      return "sql";
    case "yaml":
    case "yml":
      return "yaml";
    default:
      return "plaintext";
  }
}

export function CodeEditor({ value, path, onChange, onSave, readOnly }: CodeEditorProps) {
  const language = guessLanguage(path);

  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center justify-between border-b bg-card px-3 py-2">
        <span className="text-xs font-medium text-muted-foreground">{path}</span>
        {!readOnly && onSave && (
          <Button size="sm" onClick={onSave}>
            保存
          </Button>
        )}
      </div>
      <div className="flex-1">
        <Editor
          height="100%"
          language={language}
          value={value}
          theme="vs-light"
          options={{
            readOnly,
            minimap: { enabled: false },
            fontSize: 13,
            automaticLayout: true,
            scrollBeyondLastLine: false,
          }}
          onChange={(v) => onChange?.(v ?? "")}
        />
      </div>
    </div>
  );
}
